import React, { Component } from "react";
import { registerForLocalization, provideLocalizationService } from "@progress/kendo-react-intl";
import LoadingPanel from "../../common/LoadingPanel";
import { Grid, GridColumn } from "@progress/kendo-react-grid";

class TextNegenerovaneSpravy extends Component {
    lastSelectedIndex = 0;
    state = {
        loading: false
    };

    changeSelectedItemId = (e) => {
        var items = this.props.items;

        let last = this.lastSelectedIndex;
        const current = items.findIndex((dataItem) => dataItem === e.dataItem);

        if (!e.nativeEvent.shiftKey) {
            this.lastSelectedIndex = last = current;
        }

        if (!e.nativeEvent.ctrlKey) {
            items.forEach((item) => (item.selected = false));
        }
        const select = !e.dataItem.selected;
        for (let i = Math.min(last, current); i <= Math.max(last, current); i++) {
            items[i].selected = select;
        }
        this.props.changeSelectedItemIds(items.filter((dataItem) => dataItem.selected).map((a) => a.idtext));

        this.forceUpdate();
    };

    renderTable(items) {
        var localizationService = provideLocalizationService(this);

        return (
            <div id="NegenerovaneSpravy" onMouseDown={(e) => e.preventDefault() /* prevents browser text selection */}>
                <Grid data={items} selectedField="selected" onRowClick={this.changeSelectedItemId}>
                    <GridColumn field="idtext" title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.IDText", "IDText")} />
                    <GridColumn field="iddodavka" title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.IDDodavka", "IDDodavka")} />
                    <GridColumn field="ciarovyKod" title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.Čárový kód", "Čárový kód")} />
                    <GridColumn field="skratkaFrom" title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.Odosielateľ", "Odosielateľ")} />
                    <GridColumn field="skratkaTo" title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.Príjemca", "Príjemca")} />
                    <GridColumn
                        field="datum"
                        title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.Prijetí dodávky", "Prijetí dodávky")}
                        format="{0:d.M.yyyy H:mm}"
                    />
                    <GridColumn field="popis" title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.Popis", "Popis")} width="400px" />
                    <GridColumn field="uzivatelMeno" title={localizationService.toLanguageString("TextNegenerovaneSpravy.Grid.Prijal", "Prijal")} />
                </Grid>
            </div>
        );
    }

    render() {
        let contents = this.state.loading ? <LoadingPanel /> : this.renderTable(this.props.items);

        return <div>{contents}</div>;
    }
}

export default TextNegenerovaneSpravy;

registerForLocalization(TextNegenerovaneSpravy);



// WEBPACK FOOTER //
// ./src/components/views/Tools/TextNegenerovaneSpravy.js